import React from 'react';
import { Droplets } from 'lucide-react';

interface LoadingScreenProps {
  isLoading: boolean;
}

const LoadingScreen: React.FC<LoadingScreenProps> = ({ isLoading }) => {
  if (!isLoading) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50 bg-background/95 backdrop-blur-md">
      <div className="flex flex-col items-center">
        <div className="relative">
          <Droplets className="w-14 h-14 text-primary animate-pulse" />
          <div className="absolute inset-0 bg-primary/30 blur-2xl rounded-full" />
        </div>
        <p className="mt-6 text-foreground text-sm font-medium tracking-[0.3em] uppercase">
          Loading
        </p>
      </div>
    </div>
  );
};

export default LoadingScreen;
